// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
export * from './basicEnrollmentApi';
import { BasicEnrollmentApi } from './basicEnrollmentApi';
export * from './basicEnrollmentWithPdfApi';
import { BasicEnrollmentWithPdfApi } from './basicEnrollmentWithPdfApi';
export * from './defaultApi';
import { DefaultApi } from './defaultApi';
export * from './enrollmentApi';
import { EnrollmentApi } from './enrollmentApi';
export * from './enrollmentCommTypeApi';
import { EnrollmentCommTypeApi } from './enrollmentCommTypeApi';
export * from './enrollmentUpdateApi';
import { EnrollmentUpdateApi } from './enrollmentUpdateApi';
export * from './expressEnrollmentApi';
import { ExpressEnrollmentApi } from './expressEnrollmentApi';
export * from './expressEnrollmentUpdateApi';
import { ExpressEnrollmentUpdateApi } from './expressEnrollmentUpdateApi';
export * from './gileadEnrollmentApi';
import { GileadEnrollmentApi } from './gileadEnrollmentApi';
export * from './gileadReEnrollmentApi';
import { GileadReEnrollmentApi } from './gileadReEnrollmentApi';
export * from './gileadWithdrawalApi';
import { GileadWithdrawalApi } from './gileadWithdrawalApi';
export * from './governmentExclusionEligibilityApi';
import { GovernmentExclusionEligibilityApi } from './governmentExclusionEligibilityApi';
export * from './hybridEnrollmentApi';
import { HybridEnrollmentApi } from './hybridEnrollmentApi';
export * from './hybridEnrollmentOptOutApi';
import { HybridEnrollmentOptOutApi } from './hybridEnrollmentOptOutApi';
export * from './hybridEnrollmentUpdateApi';
import { HybridEnrollmentUpdateApi } from './hybridEnrollmentUpdateApi';
export * from './hybridPatientLookupApi';
import { HybridPatientLookupApi } from './hybridPatientLookupApi';
export * from './hybridPatientSearchApi';
import { HybridPatientSearchApi } from './hybridPatientSearchApi';
export * from './medBenefitEnrollmentApi';
import { MedBenefitEnrollmentApi } from './medBenefitEnrollmentApi';
export * from './medBenefitEnrollmentOptOutApi';
import { MedBenefitEnrollmentOptOutApi } from './medBenefitEnrollmentOptOutApi';
export * from './medBenefitEnrollmentUpdateApi';
import { MedBenefitEnrollmentUpdateApi } from './medBenefitEnrollmentUpdateApi';
export * from './medBenefitPatientLookupApi';
import { MedBenefitPatientLookupApi } from './medBenefitPatientLookupApi';
export * from './medBenefitPatientSearchApi';
import { MedBenefitPatientSearchApi } from './medBenefitPatientSearchApi';
export * from './medBenefitPrescriberApi';
import { MedBenefitPrescriberApi } from './medBenefitPrescriberApi';
export * from './medBenefitSiteApi';
import { MedBenefitSiteApi } from './medBenefitSiteApi';
export * from './patientApi';
import { PatientApi } from './patientApi';
export * from './patientSearchApi';
import { PatientSearchApi } from './patientSearchApi';
export * from './postmanApi';
import { PostmanApi } from './postmanApi';
export * from './reenrollmentEligibilityApi';
import { ReenrollmentEligibilityApi } from './reenrollmentEligibilityApi';
export * from './resendCorrespondenceApi';
import { ResendCorrespondenceApi } from './resendCorrespondenceApi';
export * from './simplePtSearchApi';
import { SimplePtSearchApi } from './simplePtSearchApi';
export * from './verifySurveyAnswerApi';
import { VerifySurveyAnswerApi } from './verifySurveyAnswerApi';
import { Lazy, Scoped } from 'vue-di';
export * from './configure';
let EnrollmentExtV3Api = class EnrollmentExtV3Api {
    constructor(_basicEnrollment, _basicEnrollmentWithPdf, _default, _enrollment, _enrollmentCommType, _enrollmentUpdate, _expressEnrollment, _expressEnrollmentUpdate, _gileadEnrollment, _gileadReEnrollment, _gileadWithdrawal, _governmentExclusionEligibility, _hybridEnrollment, _hybridEnrollmentOptOut, _hybridEnrollmentUpdate, _hybridPatientLookup, _hybridPatientSearch, _medBenefitEnrollment, _medBenefitEnrollmentOptOut, _medBenefitEnrollmentUpdate, _medBenefitPatientLookup, _medBenefitPatientSearch, _medBenefitPrescriber, _medBenefitSite, _patient, _patientSearch, _postman, _reenrollmentEligibility, _resendCorrespondence, _simplePtSearch, _verifySurveyAnswer) {
        this._basicEnrollment = _basicEnrollment;
        this._basicEnrollmentWithPdf = _basicEnrollmentWithPdf;
        this._default = _default;
        this._enrollment = _enrollment;
        this._enrollmentCommType = _enrollmentCommType;
        this._enrollmentUpdate = _enrollmentUpdate;
        this._expressEnrollment = _expressEnrollment;
        this._expressEnrollmentUpdate = _expressEnrollmentUpdate;
        this._gileadEnrollment = _gileadEnrollment;
        this._gileadReEnrollment = _gileadReEnrollment;
        this._gileadWithdrawal = _gileadWithdrawal;
        this._governmentExclusionEligibility = _governmentExclusionEligibility;
        this._hybridEnrollment = _hybridEnrollment;
        this._hybridEnrollmentOptOut = _hybridEnrollmentOptOut;
        this._hybridEnrollmentUpdate = _hybridEnrollmentUpdate;
        this._hybridPatientLookup = _hybridPatientLookup;
        this._hybridPatientSearch = _hybridPatientSearch;
        this._medBenefitEnrollment = _medBenefitEnrollment;
        this._medBenefitEnrollmentOptOut = _medBenefitEnrollmentOptOut;
        this._medBenefitEnrollmentUpdate = _medBenefitEnrollmentUpdate;
        this._medBenefitPatientLookup = _medBenefitPatientLookup;
        this._medBenefitPatientSearch = _medBenefitPatientSearch;
        this._medBenefitPrescriber = _medBenefitPrescriber;
        this._medBenefitSite = _medBenefitSite;
        this._patient = _patient;
        this._patientSearch = _patientSearch;
        this._postman = _postman;
        this._reenrollmentEligibility = _reenrollmentEligibility;
        this._resendCorrespondence = _resendCorrespondence;
        this._simplePtSearch = _simplePtSearch;
        this._verifySurveyAnswer = _verifySurveyAnswer;
    }
    get basicEnrollment() { return this._basicEnrollment(); }
    get basicEnrollmentWithPdf() { return this._basicEnrollmentWithPdf(); }
    get default() { return this._default(); }
    get enrollment() { return this._enrollment(); }
    get enrollmentCommType() { return this._enrollmentCommType(); }
    get enrollmentUpdate() { return this._enrollmentUpdate(); }
    get expressEnrollment() { return this._expressEnrollment(); }
    get expressEnrollmentUpdate() { return this._expressEnrollmentUpdate(); }
    get gileadEnrollment() { return this._gileadEnrollment(); }
    get gileadReEnrollment() { return this._gileadReEnrollment(); }
    get gileadWithdrawal() { return this._gileadWithdrawal(); }
    get governmentExclusionEligibility() { return this._governmentExclusionEligibility(); }
    get hybridEnrollment() { return this._hybridEnrollment(); }
    get hybridEnrollmentOptOut() { return this._hybridEnrollmentOptOut(); }
    get hybridEnrollmentUpdate() { return this._hybridEnrollmentUpdate(); }
    get hybridPatientLookup() { return this._hybridPatientLookup(); }
    get hybridPatientSearch() { return this._hybridPatientSearch(); }
    get medBenefitEnrollment() { return this._medBenefitEnrollment(); }
    get medBenefitEnrollmentOptOut() { return this._medBenefitEnrollmentOptOut(); }
    get medBenefitEnrollmentUpdate() { return this._medBenefitEnrollmentUpdate(); }
    get medBenefitPatientLookup() { return this._medBenefitPatientLookup(); }
    get medBenefitPatientSearch() { return this._medBenefitPatientSearch(); }
    get medBenefitPrescriber() { return this._medBenefitPrescriber(); }
    get medBenefitSite() { return this._medBenefitSite(); }
    get patient() { return this._patient(); }
    get patientSearch() { return this._patientSearch(); }
    get postman() { return this._postman(); }
    get reenrollmentEligibility() { return this._reenrollmentEligibility(); }
    get resendCorrespondence() { return this._resendCorrespondence(); }
    get simplePtSearch() { return this._simplePtSearch(); }
    get verifySurveyAnswer() { return this._verifySurveyAnswer(); }
};
EnrollmentExtV3Api = __decorate([
    Scoped,
    __param(0, Lazy(BasicEnrollmentApi)),
    __param(1, Lazy(BasicEnrollmentWithPdfApi)),
    __param(2, Lazy(DefaultApi)),
    __param(3, Lazy(EnrollmentApi)),
    __param(4, Lazy(EnrollmentCommTypeApi)),
    __param(5, Lazy(EnrollmentUpdateApi)),
    __param(6, Lazy(ExpressEnrollmentApi)),
    __param(7, Lazy(ExpressEnrollmentUpdateApi)),
    __param(8, Lazy(GileadEnrollmentApi)),
    __param(9, Lazy(GileadReEnrollmentApi)),
    __param(10, Lazy(GileadWithdrawalApi)),
    __param(11, Lazy(GovernmentExclusionEligibilityApi)),
    __param(12, Lazy(HybridEnrollmentApi)),
    __param(13, Lazy(HybridEnrollmentOptOutApi)),
    __param(14, Lazy(HybridEnrollmentUpdateApi)),
    __param(15, Lazy(HybridPatientLookupApi)),
    __param(16, Lazy(HybridPatientSearchApi)),
    __param(17, Lazy(MedBenefitEnrollmentApi)),
    __param(18, Lazy(MedBenefitEnrollmentOptOutApi)),
    __param(19, Lazy(MedBenefitEnrollmentUpdateApi)),
    __param(20, Lazy(MedBenefitPatientLookupApi)),
    __param(21, Lazy(MedBenefitPatientSearchApi)),
    __param(22, Lazy(MedBenefitPrescriberApi)),
    __param(23, Lazy(MedBenefitSiteApi)),
    __param(24, Lazy(PatientApi)),
    __param(25, Lazy(PatientSearchApi)),
    __param(26, Lazy(PostmanApi)),
    __param(27, Lazy(ReenrollmentEligibilityApi)),
    __param(28, Lazy(ResendCorrespondenceApi)),
    __param(29, Lazy(SimplePtSearchApi)),
    __param(30, Lazy(VerifySurveyAnswerApi)),
    __metadata("design:paramtypes", [Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function])
], EnrollmentExtV3Api);
export { EnrollmentExtV3Api };
//# sourceMappingURL=apis.js.map